import Notifications from '../components/notifications';
import React from 'react';
import Constants from '../const';
import Navbar from '../components/navbar.jsx';
import { selectContentId } from '../selectors/route_params';
import OfflineSetup from '../components/offline_setup.jsx';
import connect from '../components/connect';
import { isConnected } from '../selectors/offline.js';
import classnames from 'classnames';
import { swEnabled } from '../engage_cache';
import AuralNotification from 'components/aural_notification';
import SkipLink from 'components/skip_link';

/*eslint no-var: [2] */
import PropTypes from 'prop-types';

import R from 'ramda';

class App extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        routes: PropTypes.array.isRequired,
        params: PropTypes.object.isRequired,
        connected: PropTypes.bool.isRequired,
    };

    renderNavbar = isSearchResults => {
        const contentId = selectContentId(this.props.params);

        return (
            <Navbar
                params={this.props.params}
                title={Constants.NAVBAR.TITLE}
                contentId={contentId}
                showSearch={true}
                isSearchResults={isSearchResults}
            />
        );
    };

    render() {
        const classes = classnames('app-wrapper', {
            offline: !this.props.connected,
            'sw-enabled': swEnabled,
        });
        // need to slightly vary the main template if in search results
        const isSearchResults = R.hasIn('queryText', this.props.params);

        return (
            <div className={classes}>
                <AuralNotification />
                <OfflineSetup />
                <SkipLink />
                <div role="banner">{this.renderNavbar(isSearchResults)}</div>
                {isSearchResults ? (
                    this.props.children
                ) : (
                    <div className="main" role="main">
                        {this.props.children}
                    </div>
                )}
                <Notifications />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        connected: isConnected(state),
    };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/controllerviews/app.jsx